export const closeModal = () => {
  setTimeout(() => {
    const modal = document.querySelector('.storeeel-modal');
    document.body.style.overflow = 'visible';
    if (modal) modal.remove();
  }, 0);
};
